'use client';
import { selectLineMarkers, type MeasuredLineLengths, } from './xychart-canvas-model';
import { XYChartAnimatedLinePath } from './XYChartAnimatedLinePath';
import { XYChartLineAreaFill } from './XYChartLineAreaFill';
import { XYChartLineEndpointDot } from './XYChartLineEndpointDot';
import { XYChartLineHoverPoint } from './XYChartLineHoverPoint';
import type { XYChartLinePathNodeInput } from './useXYChartLinePathLengths';
import type { XYChartSeriesLayout } from './xychart-types';
export interface XYChartLineSeriesItemProps {
    series: XYChartSeriesLayout;
    safeId: string;
    hoveredCategoryIndex: number | null;
    pathLengths: MeasuredLineLengths;
    seriesOpacity: number;
    onLinePathNode: (input: XYChartLinePathNodeInput) => void;
}
export function XYChartLineSeriesItem({ series, safeId, hoveredCategoryIndex, pathLengths, seriesOpacity, onLinePathNode, }: XYChartLineSeriesItemProps) {
    if (!series.linePath)
        return null;
    const measuredLength = pathLengths[series.seriesIndex] ?? 0;
    const hasMeasured = measuredLength > 0;
    const markers = selectLineMarkers({
        linePoints: series.linePoints,
        hoveredCategoryIndex,
    });
    return (
    <g>
      <XYChartLineAreaFill series={series} safeId={safeId} hasMeasured={hasMeasured} seriesOpacity={seriesOpacity}/>
      <XYChartAnimatedLinePath series={series} measuredLength={measuredLength} hasMeasured={hasMeasured} seriesOpacity={seriesOpacity} onLinePathNode={onLinePathNode}/>
      <XYChartLineEndpointDot point={markers.lastPoint} visible={markers.showLastDot} color={series.color} seriesOpacity={seriesOpacity} seriesLabel={series.label}/>
      <XYChartLineHoverPoint point={markers.hoveredPoint} color={series.color} seriesLabel={series.label}/>
    </g>
    );
}
